import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';
import useProductDocument, { ProductDocumentTabs } from './ProductDocument.Hooks';
import ProductDealerDocumentIndex from './dealers/ProductDocument.DealerDocuments.Index';
import ProductDealerGroupDocumentIndex from './dealerGroups/ProductDocument.DealerGroupDocuments.Index';
import useProductDealerDocument from './dealers/ProductDocument.DealerDocuments.Hooks';
import useProductDealerGroupDocument from './dealerGroups/ProductDocument.DealerGroupDocuments.Hooks';

enum Actions {
  ADD = 'add',
  DELETE = 'delete',
}
export type Verify = Utils.VerifyExtends<
  Module.ProductManagement.ProductDocument.Actions,
  Utils.ValueOf<typeof Actions>
>;
export const productDocumentIndexRoute = productManagementHomeRoute + '/productDocument/:id?';
export default function ProductDocumentIndex() {
  const productDocumentHook = useProductDocument();
  const productDealerDocumentHook = useProductDealerDocument();
  const productDealerGroupDocumentHook = useProductDealerGroupDocument();

  if (!productDocumentHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <DataProvider
      data={{
        productDocumentHook: productDocumentHook,
        productDealerDocumentHook: productDealerDocumentHook,
        productDealerGroupDocumentHook: productDealerGroupDocumentHook,
      }}
      render={({ productDocumentHook }) =>
        productDocumentHook.selectedTab === ProductDocumentTabs.DEALERS ? (
          <ProductDealerDocumentIndex />
        ) : (
          <ProductDealerGroupDocumentIndex />
        )
      }
    />
  );
}
